<template>
  <div>
    <FormSectionContainer index="1" title="Pályázat alapadatai">
      <b-row class="mb-3">
        <b-col cols="6">
          <label for="applicationData.applicationMin">Támogatási összeg minimuma</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="applicationData.applicationMin"
              v-model="applicationData.applicationMin"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a pályázható összeg minimumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="6">
          <label for="applicationData.applicationMax">Támogatási összeg maximuma</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="applicationData.applicationMax"
              v-model="applicationData.applicationMax"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a pályázható összeg maximumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <label for="applicationData.determineAmount">Összeg megállapításának módja</label>
      <b-form-textarea
        id="applicationData.determineAmount"
        v-model="applicationData.determineAmount"
        placeholder="Adja meg a támogatási összeg megállapításának módját"
        trim
        rows="6"
        style="min-height: 150px;"
        class="mb-3"
      ></b-form-textarea>

      <label for="applicationData.intensivityOfApplication"
        >Támogatás intenzitás<span class="required-star"></span
      ></label>
      <b-form-textarea
        id="applicationData.intensivityOfApplication"
        v-model="applicationData.intensivityOfApplication"
        placeholder="Adja meg a támogatás intenzitását"
        trim
        rows="6"
        style="min-height: 150px;"
        :state="intensivityOfApplication"
        :class="`${intensivityOfApplication !== null && !intensivityOfApplication ? 'create-fund-error-border' : ''}`"
      ></b-form-textarea>

      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adja meg a támogatás intenzitását
      </b-form-invalid-feedback>

      <label for="applicationData.selfContribution" class="mt-3">Önerő</label>
      <b-form-input
        id="applicationData.selfContribution"
        v-model="applicationData.selfContribution"
        placeholder="Adja meg az önerőt."
        trim
      ></b-form-input>
    </FormSectionContainer>

    <FormSectionContainer index="2" title="Előminősítés és regisztráció">
      <div
        :class="
          ` ${
            this.isDateOpen &&
            ((!preQualification.isActive && preRegistration.isActive) ||
              (preQualification.isActive && !preRegistration.isActive))
              ? 'singe-check-date-extended-container'
              : this.isDateOpen && preQualification.isActive && preRegistration.isActive
              ? 'double-check-date-extended-container'
              : this.isTimeOpen &&
                ((!preQualification.isActive && preRegistration.isActive) ||
                  (preQualification.isActive && !preRegistration.isActive))
              ? 'singe-check-time-extended-container'
              : this.isTimeOpen && preQualification.isActive && preRegistration.isActive
              ? 'double-check-time-extended-container'
              : ''
          }`
        "
      >
        <b-form-checkbox id="checkbox-1" v-model="preQualification.isActive" name="checkbox-1">
          A termék igényvetételéhez előminősítésen kell átesni?
        </b-form-checkbox>

        <section v-show="preQualification.isActive">
          <b-row class="d-flex justify-content-center component-container mt-3">
            <DatePicker
              title="Előminősítés kezdete"
              @shown="isDatePickerOpen($event)"
              @hidden="isDatePickerOpen($event)"
              @date-value="onPreQualificationStartDateSelect($event)"
              uniqueId="datepicker-1"
              :error="this.touched && !this.preQualificationStartDate"
              errorMessage="Válasszon egy, az előminősítés végénél korábbi dátumot."
              required
              @which-component-is-open="handleDateComponentLayout($event)"
              :class="`${this.openDateComponent == 'datepicker-1' ? 'extended-date-layout' : ''}`"
              :alreadySelected="this.preQualification.startDate"
              :key="this.preQResultDates.startDate ? this.preQResultDates.startDate : 'preQResultDatesStartDate'"
            />

            <TimePicker
              title="Előminősítés kezdete"
              @shown="isTimePickerOpen($event)"
              @hidden="isTimePickerOpen($event)"
              @time-value="onPreQualificationStartTimeSelect($event)"
              uniqueId="timepicker-1"
              @which-component-is-open="handleTimeComponentLayout($event)"
              :class="`${this.openTimeComponent == 'timepicker-1' ? 'extended-time-layout' : ''}`"
              :alreadySelected="this.preQualification.startTime"
              :key="this.preQResultDates.startTime"
            />
          </b-row>

          <b-row class="d-flex justify-content-center component-container mt-3">
            <DatePicker
              title="Előminősítés vége"
              @shown="isDatePickerOpen($event)"
              @hidden="isDatePickerOpen($event)"
              @date-value="onPreQualificationEndDateSelect($event)"
              uniqueId="datepicker-2"
              :error="this.touched && !this.preQualificationEndDate"
              errorMessage="Válasszon egy, az előminősítés kezdeténél későbbi dátumot."
              required
              @which-component-is-open="handleDateComponentLayout($event)"
              :class="`${this.openDateComponent == 'datepicker-2' ? 'extended-date-layout' : ''}`"
              :alreadySelected="this.preQualification.endDate"
              :key="this.preQResultDates.endDate ? this.preQResultDates.endDate : 'preQResultDatesEndDate'"
            />

            <TimePicker
              title="Előminősítés vége"
              @shown="isTimePickerOpen($event)"
              @hidden="isTimePickerOpen($event)"
              @time-value="onPreQualificationEndTimeSelect($event)"
              uniqueId="timepicker-2"
              @which-component-is-open="handleTimeComponentLayout($event)"
              :class="`${this.openTimeComponent == 'timepicker-2' ? 'extended-time-layout' : ''}`"
              :alreadySelected="this.preQualification.endTime"
              :key="this.preQResultDates.endTime"
            />
          </b-row>

          <b-row>
            <b-col>
              <label for="preQualification.link" class="mt-3"
                >Előminősítési link<span class="required-star"></span
              ></label>
              <b-form-input
                id="preQualification.link"
                v-model="preQualification.link"
                placeholder="Adja meg az előminősítési oldal hivatkozását"
                trim
                :state="preQualificationLink"
                :class="`${preQualificationLink !== null && !preQualificationLink ? 'create-fund-error-border' : ''}`"
              ></b-form-input>
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                A linknek https:// előtaggal kell kezdődnie
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </section>

        <b-form-checkbox id="checkbox-2" v-model="preRegistration.isActive" name="checkbox-2" class="mt-5">
          A termék igénybevétele regisztrációhoz kötött?
        </b-form-checkbox>

        <section v-show="preRegistration.isActive">
          <b-row class="d-flex justify-content-center component-container mt-3">
            <DatePicker
              title="Regisztráció kezdete"
              @shown="isDatePickerOpen($event)"
              @hidden="isDatePickerOpen($event)"
              @date-value="onPreRegistrationStartDateSelect($event)"
              uniqueId="datepicker-3"
              :error="this.touched && !this.preRegistrationStartDate"
              errorMessage="Válasszon egy, a regisztráció végénél korábbi dátumot."
              required
              @which-component-is-open="handleDateComponentLayout($event)"
              :class="`${this.openDateComponent == 'datepicker-3' ? 'extended-date-layout' : ''}`"
              :alreadySelected="this.preRegistration.startDate"
              :key="this.preRResultDates.startDate ? this.preRResultDates.startDate : 'preRResultDatesStartDate'"
            />

            <TimePicker
              title="Regisztráció kezdete"
              @shown="isTimePickerOpen($event)"
              @hidden="isTimePickerOpen($event)"
              @time-value="onPreRegistrationStartTimeSelect($event)"
              uniqueId="timepicker-3"
              @which-component-is-open="handleTimeComponentLayout($event)"
              :class="`${this.openTimeComponent == 'timepicker-3' ? 'extended-time-layout' : ''}`"
              :alreadySelected="this.preRegistration.startTime"
              :key="this.preRResultDates.startTime"
            />
          </b-row>

          <b-row class="d-flex justify-content-center component-container mt-3">
            <DatePicker
              title="Regisztráció vége"
              @shown="isDatePickerOpen($event)"
              @hidden="isDatePickerOpen($event)"
              @date-value="onPreRegistrationEndDateSelect($event)"
              uniqueId="datepicker-4"
              :error="this.touched && !this.preRegistrationEndDate"
              errorMessage="Válasszon egy, a regisztráció kezdeténél későbbi dátumot."
              required
              @which-component-is-open="handleDateComponentLayout($event)"
              :class="`${this.openDateComponent == 'datepicker-4' ? 'extended-date-layout' : ''}`"
              :alreadySelected="this.preRegistration.endDate"
              :key="this.preRResultDates.endDate ? this.preRResultDates.endDate : 'preRResultDatesEndDate'"
            />

            <TimePicker
              title="Regisztráció vége"
              @shown="isTimePickerOpen($event)"
              @hidden="isTimePickerOpen($event)"
              @time-value="onPreRegistrationEndTimeSelect($event)"
              uniqueId="timepicker-4"
              @which-component-is-open="handleTimeComponentLayout($event)"
              :class="`${this.openTimeComponent == 'timepicker-4' ? 'extended-time-layout' : ''}`"
              :alreadySelected="this.preRegistration.endTime"
              :key="this.preRResultDates.endTime"
            />
          </b-row>

          <b-row>
            <b-col>
              <label for="preRegistration.link" class="mt-3"
                >Regisztrációs link<span class="required-star"></span
              ></label>
              <b-form-input
                id="preRegistration.link"
                v-model="preRegistration.link"
                placeholder="Adja meg az regisztrációs oldal hivatkozását"
                trim
                :state="preRegistrationLink"
                :class="`${preRegistrationLink !== null && !preRegistrationLink ? 'create-fund-error-border' : ''}`"
              ></b-form-input>
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                A linknek https:// előtaggal kell kezdődnie
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </section>
      </div>
    </FormSectionContainer>

    <FormSectionContainer
      index="3"
      title="Szövegesen megjelenő feltételek, kizárások"
      :key="this.guarantee.uniqueConditions[0] ? this.guarantee.uniqueConditions[0].id : 'unqiue'"
    >
      <UniqueConditionsSelector
        @unique-conditions="handleUniqueConditions($event)"
        :alreadySelected="guarantee.uniqueConditions"
      />
    </FormSectionContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormSectionContainer from '../components/FormSectionContainer.vue'
import UniqueConditionsSelector from '../components/UniqueConditionsSelector.vue'
import DatePicker from '../components/DatePicker.vue'
import TimePicker from '../components/TimePicker.vue'
import * as CompetitionApi from '../../../api/competition'
export default {
  props: {
    isTouched: { type: Boolean, required: true }
  },
  data() {
    return {
      applicationData: {
        applicationMin: '',
        applicationMax: '',
        determineAmount: '',
        intensivityOfApplication: '',
        selfContribution: ''
      },
      preQualification: { isActive: false, link: '', startDate: '', startTime: '', endDate: '', endTime: '' },
      preRegistration: { isActive: false, link: '', startDate: '', startTime: '', endDate: '', endTime: '' },
      guarantee: {
        uniqueConditions: []
      },
      openDateComponent: '',
      openTimeComponent: '',
      touched: this.isTouched,
      preQResultDates: {},
      preRResultDates: {}
    }
  },
  components: {
    FormSectionContainer,
    UniqueConditionsSelector,
    DatePicker,
    TimePicker
  },
  computed: {
    ...mapGetters(['newFundDto']),

    intensivityOfApplication() {
      if (this.touched) {
        return this.applicationData.intensivityOfApplication.length > 0
      } else {
        return null
      }
    },
    preQualificationStartDate() {
      if (!this.preQualification.isActive) {
        return true
      }
      if (this.touched) {
        return (
          this.preQualification.startDate.length > 0 &&
          new Date(this.preQualification.startDate) < new Date(this.preQualification.endDate)
        )
      } else {
        return null
      }
    },
    preQualificationEndDate() {
      if (!this.preQualification.isActive) {
        return true
      }
      if (this.touched) {
        return (
          this.preQualification.endDate.length > 0 &&
          new Date(this.preQualification.startDate) < new Date(this.preQualification.endDate)
        )
      } else {
        return null
      }
    },
    preQualificationLink() {
      if (!this.preQualification.isActive) {
        return true
      }
      if (this.touched) {
        return this.preQualification.link.slice(0, 8) === 'https://'
      } else {
        return null
      }
    },
    preRegistrationStartDate() {
      if (!this.preRegistration.isActive) {
        return true
      }
      if (this.touched) {
        return (
          this.preRegistration.startDate.length > 0 &&
          new Date(this.preRegistration.startDate) < new Date(this.preRegistration.endDate)
        )
      } else {
        return null
      }
    },
    preRegistrationEndDate() {
      if (!this.preRegistration.isActive) {
        return true
      }
      if (this.touched) {
        return (
          this.preRegistration.startDate.length > 0 &&
          new Date(this.preRegistration.startDate) < new Date(this.preRegistration.endDate)
        )
      } else {
        return null
      }
    },
    preRegistrationLink() {
      if (!this.preRegistration.isActive) {
        return true
      }
      if (this.touched) {
        return this.preRegistration.link.slice(0, 8) === 'https://'
      } else {
        return null
      }
    },
    finalResult() {
      if (
        this.applicationData.intensivityOfApplication.length > 0 &&
        (!this.preQualification.isActive || this.preQualification.startDate.length > 0) &&
        (!this.preQualification.isActive || this.preQualification.endDate.length > 0) &&
        (!this.preQualification.isActive || this.preQualification.link.slice(0, 8) === 'https://') &&
        (!this.preQualification.isActive ||
          new Date(this.preQualification.startDate) < new Date(this.preQualification.endDate)) &&
        (!this.preRegistration.isActive || this.preRegistration.startDate.length > 0) &&
        (!this.preRegistration.isActive || this.preRegistration.endDate.length > 0) &&
        (!this.preRegistration.isActive || this.preRegistration.link.slice(0, 8) === 'https://') &&
        (!this.preRegistration.isActive ||
          new Date(this.preRegistration.startDate) < new Date(this.preRegistration.endDate))
      ) {
        return this.$emit('is-step2-fields-filled', true)
      } else {
        return this.$emit('is-step2-fields-filled', false)
      }
    }
  },
  methods: {
    isNumber(evt, isMinusAllowed) {
      const isStarting0Allowed = !this.$route.path.includes('/create-fund')
      const input = evt.target.value
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (keyPressed === '-' && input.length === 0 && isMinusAllowed) {
        return
      }

      if (input.length === 0 && keyPressed === '0' && isStarting0Allowed) {
        evt.preventDefault()
        return
      }

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    addCompetitionAttribute(key, value) {
      this.$store.dispatch('setFundDtoPropertyAction', { [key]: value })
    },
    handleUniqueConditions(conditions) {
      this.guarantee.uniqueConditions = conditions
    },
    isDatePickerOpen(toggle) {
      this.isDateOpen = toggle
    },
    isTimePickerOpen(toggle) {
      this.isTimeOpen = toggle
    },
    handleDateComponentLayout(id) {
      this.openDateComponent = id
    },
    handleTimeComponentLayout(id) {
      this.openTimeComponent = id
    },
    onPreQualificationStartDateSelect(date) {
      this.preQualification.startDate = date
    },
    onPreQualificationStartTimeSelect(time) {
      this.preQualification.startTime = time
    },
    onPreQualificationEndDateSelect(date) {
      this.preQualification.endDate = date
    },
    onPreQualificationEndTimeSelect(time) {
      this.preQualification.endTime = time
    },
    onPreRegistrationStartDateSelect(date) {
      this.preRegistration.startDate = date
    },
    onPreRegistrationStartTimeSelect(time) {
      this.preRegistration.startTime = time
    },
    onPreRegistrationEndDateSelect(date) {
      this.preRegistration.endDate = date
    },
    onPreRegistrationEndTimeSelect(time) {
      this.preRegistration.endTime = time
    }
  },
  watch: {
    applicationData: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('applicationData', value)
      },
      deep: true
    },
    preQualification: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('preQualification', value)
      },
      deep: true
    },
    preRegistration: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('preRegistration', value)
      },
      deep: true
    },
    guarantee: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('guarantee', value)
      },
      deep: true
    },
    isTouched() {
      this.touched = this.isTouched
    }
  },
  async beforeMount() {
    const { competitionId } = this.$route.query
    if (competitionId) {
      try {
        const fundResult = await CompetitionApi.getCompetitionWithDetails(competitionId)
        this.applicationData = fundResult.fundId.applicationData

        if (fundResult.fundId.preQualification && fundResult.fundId.preQualification.isActive) {
          this.preQResultDates = fundResult.fundId.preQualification

          this.preQualification.startDate = this.preQResultDates.startDate.split('T')[0]
          this.preQualification.startTime =
            this.preQResultDates.startTime || this.preQResultDates.startDate.split('T')[1].slice(0, -5)
          this.preQualification.endDate = this.preQResultDates.endDate.split('T')[0]
          this.preQualification.endTime = this.preQResultDates.endTime
            ? this.preQResultDates.endTime
            : this.preQResultDates.endDate.split('T')[1].slice(0, -5)
          this.preQualification.isActive = this.preQResultDates.isActive
          this.preQualification.link = this.preQResultDates.link
        }

        if (fundResult.fundId.preRegistration && fundResult.fundId.preRegistration.isActive) {
          this.preRResultDates = fundResult.fundId.preRegistration

          this.preRegistration.startDate = this.preRResultDates.startDate.split('T')[0]
          this.preRegistration.startTime =
            this.preRResultDates.startTime || this.preRResultDates.startDate.split('T')[1].slice(0, -5)

          this.preRegistration.endDate = this.preRResultDates.endDate.split('T')[0]
          this.preRegistration.endTime =
            this.preRResultDates.endTime || this.preRResultDates.endDate.split('T')[1].slice(0, -5)

          this.preRegistration.isActive = this.preRResultDates.isActive
          this.preRegistration.link = this.preRResultDates.link
        }

        this.guarantee = fundResult.fundId.guarantee
      } catch (e) {
        console.log(e)
      }
    } else {
      if (this.newFundDto.guarantee) {
        this.guarantee = this.newFundDto.guarantee
      }
      if (this.newFundDto.applicationData) {
        this.applicationData = this.newFundDto.applicationData
      }
      if (this.newFundDto.preQualification) {
        this.preQualification = this.newFundDto.preQualification
      }
      if (this.newFundDto.preRegistration) {
        this.preRegistration = this.newFundDto.preRegistration
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-text {
  font-weight: 400;
  font-size: 14px;
  color: black;
  text-transform: none;
}

input[type='radio'] {
  width: 20px;
  height: 20px;
  border: 1px solid #bbc1d3;
}

input[type='radio']:after {
  border-radius: 20px;
  content: '';
  display: inline-block;
}

input[type='radio']:checked:after {
  width: 20px;
  height: 20px;
  background-color: white;
  border: 6px solid #00903c;
}

.singe-check-date-extended-container {
  height: 1000px !important;
}

.double-check-date-extended-container {
  height: 1300px !important;
}

.singe-check-time-extended-container {
  height: 600px !important;
}

.double-check-time-extended-container {
  height: 950px !important;
}

.extended-date-layout {
  margin-bottom: 600px !important;
}

.extended-time-layout {
  margin-bottom: 250px !important;
}

@media (max-width: 767px) {
  .component-container {
    display: unset !important;
  }

  .extended-date-layout {
    margin-bottom: 450px !important;
  }

  .double-check-time-extended-container {
    height: 1350px !important;
  }

  .double-check-date-extended-container {
    height: 1500px !important;
  }

  .singe-check-time-extended-container {
    height: 800px !important;
  }
}

.radio-button {
  margin-top: 5px;
}

@media all and (max-width: 576px) {
  .radio-button {
    margin-left: 10px;
    margin-top: 10px;
  }
}

.create-fund-error-border {
  border: 2px solid #ba3b46 !important;
}

.create-fund-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}
</style>
